import React from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { SearchIcon, Loader2Icon } from "lucide-react";

interface DateRangeFilterProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  onClearFilters: () => void;
  onSearch: () => void;
  isLoading: boolean;
}

const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onClearFilters,
  onSearch,
  isLoading,
}) => {
  return (
    <div className="flex items-center gap-3">
      <Input
        placeholder="Start Date"
        className="w-40"
        type="date"
        value={startDate}
        onChange={(e) => onStartDateChange(e.target.value)}
      />
      <Input
        placeholder="End Date"
        className="w-40"
        type="date"
        value={endDate}
        onChange={(e) => onEndDateChange(e.target.value)}
      />
      <Button
        variant="outline"
        onClick={onClearFilters}
        disabled={!endDate && !startDate}
      >
        Clear
      </Button>
      <Button
        onClick={onSearch}
        disabled={isLoading}
        className="gap-2"
      >
        {isLoading ? (
          <Loader2Icon className="w-4 h-4 animate-spin" />
        ) : (
          <SearchIcon className="w-4 h-4" />
        )}
        Search
      </Button>
    </div>
  );
};

export default DateRangeFilter; 